import { DateTime } from 'luxon';

export const SCAN_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};
const SCAN_STATUSES = Object.values(SCAN_STATUS);
const SESSION_ID_PREFIX = 'TXT_';
const SESSION_ID_PATTERN = /^TXT_[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const TRANSACTION_ID_PATTERN = /^TXT_[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}-\d+$/i;
const TIMESTAMP_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
const SCAN_SESSION_KEY = 'idScanUsageSessionId';
const APPLICATION_ACTION_CD = 'ACCT_CREATION';
const PRODUCT_CD = 'ID_SCAN_SDK';
let fallbackSessionId;

export function getScanSessionId() {
  let sessionId;
  try {
    sessionId = window.sessionStorage.getItem(SCAN_SESSION_KEY);
  } catch {
    sessionId = fallbackSessionId;
  }
  if (!sessionId || !SESSION_ID_PATTERN.test(sessionId)) {
    sessionId = `${SESSION_ID_PREFIX}${window.crypto.randomUUID()}`;
    try {
      window.sessionStorage.setItem(SCAN_SESSION_KEY, sessionId);
    } catch {
      fallbackSessionId = sessionId;
    }
  }
  return sessionId;
}

export function createScanTransactionId() {
  const sessionId = getScanSessionId();
  return `${sessionId}-${Date.now()}`;
}

export function createScanTimestamp() {
  return DateTime.now()
    .setZone('America/Chicago')
    .toFormat("yyyy-MM-dd'T'HH:mm:ss");
}

export function recordIdScanUsageRequest(transactionId, status, timestamp) {
  if (
    typeof transactionId !== 'string' ||
    !TRANSACTION_ID_PATTERN.test(transactionId) ||
    !SCAN_STATUSES.includes(status) ||
    typeof timestamp !== 'string' ||
    !TIMESTAMP_PATTERN.test(timestamp) ||
    Number.isNaN(Date.parse(`${timestamp}Z`)) ||
    new Date(`${timestamp}Z`).toISOString().slice(0, 19) !== timestamp
  ) {
    throw new Error('Invalid ID scan usage transaction');
  }
  return {
    type: '[API] Record ID Scan Usage',
    url: '/scanservice/productusage/v1/createRecord',
    APIMethod: 'POST',
    nonBlocking: true,
    body: {
      transactionId,
      applicationActionCd: APPLICATION_ACTION_CD,
      productCd: PRODUCT_CD,
      productResponse: status,
      eventTimestamp: timestamp,
    },
  };
}
